export default function MetricCard({ icon, label, value, change, tone = "blue" }) {
  return (
    <article className="metric-card" data-testid={`metric-${label.toLowerCase().replaceAll(" ", "-")}`}>
      <div className={`metric-icon metric-icon-${tone}`}>{icon}</div>
      <p>{label}</p>
      <strong>{value}</strong>
      <small className="positive-change">↗ {change} <span>vs last 7 days</span></small>
    </article>
  );
}